export default "<i class=\"material-icons\" matTooltip=\"{{orderStatus.state}}\">\n  {{ orderStatus.icon }}\n</i>"